import { useStorage } from '@vueuse/core';

export function useMonitorStore() {
  const defaultView = useStorage(
    'monitor-default-view',
    'table',
    localStorage,
    {
      mergeDefaults: true,
      listenToStorageChanges: true,
    },
  );
  return { defaultView };
}
